import { ReactComponent as BronzeIcon } from "../assets/images/awardIcon/bronzeIcon.svg";
import { ReactComponent as CrownAmbassador } from "../assets/images/awardIcon/crownAmbassador.svg";
import { ReactComponent as CrownIcon } from "../assets/images/awardIcon/crownIcon.svg";
import { ReactComponent as DiamondIcon } from "../assets/images/awardIcon/diamondIcon.svg";
import { ReactComponent as DoubleDiamond } from "../assets/images/awardIcon/doubleDiamond.svg";
import { ReactComponent as EmeraldIcon } from "../assets/images/awardIcon/emeraldIcon.svg";
import { ReactComponent as ExecutiveDiamond } from "../assets/images/awardIcon/executiveDiamond.svg";
import { ReactComponent as GoldIcon } from "../assets/images/awardIcon/goldIcon.svg";
import { ReactComponent as PlatinumIcon } from "../assets/images/awardIcon/platinumIcon.svg";
import { ReactComponent as RubyIcon } from "../assets/images/awardIcon/rubyIcon.svg";
import { ReactComponent as SapphireIcon } from "../assets/images/awardIcon/sapphireIcon.svg";
import { ReactComponent as SilverIcon } from "../assets/images/awardIcon/silverIcon.svg";
import { ReactComponent as TripleDiamond } from "../assets/images/awardIcon/tripleDiamond.svg";
import { ReactComponent as FoundersCrown } from "../assets/images/awardIcon/foundersCrown.svg";
import { ReactComponent as FoundersCrownAmbassador } from "../assets/images/awardIcon/foundersCrownAmbassador.svg";
import { ReactComponent as FoundersDiamond } from "../assets/images/awardIcon/foundersDiamond.svg";
import { ReactComponent as FoundersDoubleDiamond } from "../assets/images/awardIcon/foundersDoubleDiamond.svg";
import { ReactComponent as FoundersEmerald } from "../assets/images/awardIcon/foundersEmerald.svg";
import { ReactComponent as FoundersExecutiveDiamond } from "../assets/images/awardIcon/foundersExecutiveDiamond.svg";
import { ReactComponent as FoundersPlatinum } from "../assets/images/awardIcon/foundersPlatinum.svg";
import { ReactComponent as FoundersRuby } from "../assets/images/awardIcon/foundersRuby.svg";
import { ReactComponent as FoundersSapphire } from "../assets/images/awardIcon/foundersSapphire.svg";
import { ReactComponent as FoundersTripleDiamond } from "../assets/images/awardIcon/foundersTripleDiamond.svg";
import { ReactComponent as PlaceHolder } from "../assets/images/awardIcon/placeHolder.svg";
import { ReactComponent as TrackingAwardTagComeback } from "../assets/images/awardIcon/TrackingAwardTagComeback.svg";
import { ReactComponent as TrackingAwardTagIncrease } from "../assets/images/awardIcon/TrackingAwardTagIncrease.svg";
import { ReactComponent as TrackingAwardTagNew } from "../assets/images/awardIcon/TrackingAwardTagNew.svg";
import { ReactComponent as TrackingAwardTagDarkComeback } from "../assets/images/awardIcon/TrackingAwardTagDarkComeback.svg";
import { ReactComponent as TrackingAwardTagDarkIncrease } from "../assets/images/awardIcon/TrackingAwardTagDarkIncrease.svg";
import { ReactComponent as TrackingAwardTagDarkNew } from "../assets/images/awardIcon/TrackingAwardTagDarkNew.svg";
import { ReactComponent as TrackingAwardReq } from "../assets/images/awardIcon/TrackingAwardReq.svg";
import { ReactComponent as TrackingAwardReqDark } from "../assets/images/awardIcon/TrackingAwardReqDark.svg";
import { ReactComponent as TrackingAwardDecline } from "../assets/images/awardIcon/TrackingAwardDecline.svg";
import { ReactComponent as TrackingAwardDeclineDark } from "../assets/images/awardIcon/TrackingAwardDeclineDark.svg";
import { ReactComponent as TrackingAwardNotTracking } from "../assets/images/awardIcon/TrackingAwardNotTracking.svg";
import { ReactComponent as TrackingAwardNotTrackingDark } from "../assets/images/awardIcon/TrackingAwardNotTrackingDark.svg";

import { TFunction } from "i18next";
import i18n from "../i18n";

export const getAwardIcon = (award: string | undefined) => {
  switch (award?.toLowerCase()) {
    case "founders crown":
      return <FoundersCrown />;
    case "founders crown ambassador":
      return <FoundersCrownAmbassador />;
    case "founders diamond":
      return <FoundersDiamond />;
    case "founders double diamond":
      return <FoundersDoubleDiamond />;
    case "founders emerald":
      return <FoundersEmerald />;
    case "founders executive diamond":
      return <FoundersExecutiveDiamond />;
    case "founders platinum":
      return <FoundersPlatinum />;
    case "founders ruby":
      return <FoundersRuby />;
    case "founders sapphire":
      return <FoundersSapphire />;
    case "founders triple diamond":
      return <FoundersTripleDiamond />;
    case "bronze":
      return <BronzeIcon />;
    case "crown ambassador":
      return <CrownAmbassador />;
    case "crown":
      return <CrownIcon />;
    case "diamond":
      return <DiamondIcon />;
    case "double diamond":
      return <DoubleDiamond />;
    case "emerald":
      return <EmeraldIcon />;
    case "executive diamond":
      return <ExecutiveDiamond />;
    case "gold":
      return <GoldIcon />;
    case "platinum":
      return <PlatinumIcon />;
    case "ruby":
      return <RubyIcon />;
    case "sapphire":
      return <SapphireIcon />;
    case "silver":
      return <SilverIcon />;
    case "triple diamond":
      return <TripleDiamond />;
    default:
      return <PlaceHolder />;
  }
};

export const getTrackingAwardIconFromCode = (
  awardCode: string | number | undefined,
  currentTheme: string
) => {
  switch (awardCode && awardCode?.toString()) {
    case "5":
      return currentTheme === "light" ? (
        <TrackingAwardDecline />
      ) : (
        <TrackingAwardDeclineDark />
      );
    case "4":
      return currentTheme === "light" ? (
        <TrackingAwardTagComeback />
      ) : (
        <TrackingAwardTagDarkComeback />
      );
    case "3":
      return currentTheme === "light" ? (
        <TrackingAwardTagIncrease />
      ) : (
        <TrackingAwardTagDarkIncrease />
      );
    case "2":
      return currentTheme === "light" ? (
        <TrackingAwardReq />
      ) : (
        <TrackingAwardReqDark />
      );
    case "1":
      return currentTheme === "light" ? (
        <TrackingAwardTagNew />
      ) : (
        <TrackingAwardTagDarkNew />
      );
    default:
      return currentTheme === "light" ? (
        <TrackingAwardNotTracking />
      ) : (
        <TrackingAwardNotTrackingDark />
      );
  }
};

export const getTrackingAwardFromCode = (
  award: string | number | undefined,
  t: any
) => {
  switch (award && award?.toString()) {
    case "1":
      return t("tracking_award_tag_names.New");
    case "2":
      return t("tracking_award_tag_names.Requalified");
    case "3":
      return t("tracking_award_tag_names.Increase");
    case "4":
      return t("tracking_award_tag_names.Comeback");
    case "5":
      return t("tracking_award_tag_names.Decline");
    case "6":
      return t("tracking_award_tag_names.notTracking");
    default:
      return t("tracking_award_tag_names.notTracking");
  }
};

export const getTrackingAwardColorFromCode = (
  award: string | number | undefined,
  currentTheme: string
) => {
  switch (award && award?.toString()) {
    case "1":
      return currentTheme === "light" ? "#5969D6" : "#99B2F5";
    case "2":
      return currentTheme === "light" ? "#396E75" : "#77CBBF";
    case "3":
      return currentTheme === "light" ? "#107F47" : "#B3D67B";
    case "4":
      return currentTheme === "light" ? "#DA7600" : "#FED773";
    case "5":
      return currentTheme === "light" ? "#D91734" : "#F16A81";
    default:
      return currentTheme === "light" ? "#707070" : "#AEAEB2";
  }
};

export const getTrackingAwardPinFromCode = (
  code: string | number | undefined
) => {
  switch (code) {
    case "385":
      return "FDI";
    default:
      return "-";
  }
};

// Mapping of Award code only For Profile subheader (All Codes here)
export const awardCodeMap: Record<string, string> = {
  "203": "award_names.Three_Percent",
  "206": "award_names.Six_Percent",
  "209": "award_names.Nine_Percent",
  "211": "award_names.Eleven_Percent",
  "212": "award_names.Twelve_Percent",
  "213": "award_names.Thirteen_Percent",
  "215": "award_names.Fifteen_Percent",
  "218": "award_names.Eighteen_Percent",
  "221": "award_names.TwentyOne_Percent",
  "223": "award_names.TwentyThree_Percent",
  "305": "award_names.Silver_Sponsor",
  "310": "award_names.Silver",
  "320": "award_names.Gold",
  "330": "award_names.Platinum",
  "340": "award_names.Ruby",
  "342": "award_names.Founders_Platinum",
  "345": "award_names.Founders_Ruby",
  "350": "award_names.Pearl",
  "365": "award_names.Sapphire",
  "367": "award_names.Founders_Sapphire",
  "370": "award_names.Emerald",
  "375": "award_names.Founders_Emerald",
  "380": "award_names.Diamond",
  "385": "award_names.Founders_Diamond",
  "390": "award_names.Executive_Diamond",
  "393": "award_names.GAR_Executive_Diamond",
  "395": "award_names.Founders_Executive_Diamond",
  "398": "award_names.GAR_Founders_Executive_Diamond",
  "400": "award_names.Double_Diamond",
  "403": "award_names.GAR_Double_Diamond",
  "405": "award_names.Founders_Double_Diamond",
  "408": "award_names.GAR_Founders_Double_Diamond",
  "410": "award_names.Triple_Diamond",
  "413": "award_names.GAR_Triple_Diamond",
  "415": "award_names.Founders_Triple_Diamond",
  "418": "award_names.GAR_Founders_Triple_Diamond",
  "420": "award_names.Crown",
  "423": "award_names.GAR_Crown",
  "425": "award_names.Founders_Crown",
  "428": "award_names.GAR_Founders_Crown",
  "430": "award_names.Crown_Ambassador",
  "433": "award_names.GAR_Crown_Ambassador",
  "435": "award_names.Founders_Crown_Ambassador",
  "438": "award_names.GAR_Founders_Crown_Ambassador",
  "440": "award_names.FCA_40",
  "445": "award_names.FCA_45",
  "450": "award_names.FCA_50",
  "455": "award_names.FCA_55",
  "460": "award_names.FCA_60",
  "465": "award_names.FCA_65",
  "470": "award_names.FCA_70"
};

export const getAwardNameFromCode = (
  code: string | number | undefined,
  t: TFunction,
  lang?: string
) => {
  if (!code) return "";
  const key = awardCodeMap[String(code)];

  if (lang) {
    try {
      const fixedT = i18n.getFixedT(lang);
      return key
      ? fixedT(key)
          .replace(/Founders/gi, "F.")
          .replace(/Executive/gi, "Exec.")
      : "";
    } catch (err) {
      console.warn("getFixedT failed:", err);
    }
  }

  return key
    ? t(key)
        .replace(/Founders/gi, "F.")
        .replace(/Executive/gi, "Exec.")
    : "";
};


export const getCountryNameFromCode = (
  countryCode: string | undefined,
  t: any
) => {
  switch (countryCode) {
    case "US":
      return t("countryNames.US");
    case "TH":
      return t("countryNames.TH");
    case "CA":
      return t("countryNames.CA");
    case "DO":
      return t("countryNames.DO");
    case "IN":
      return t("countryNames.IN");
    case "AR":
      return t("countryNames.AR");
    case "AU":
      return t("countryNames.AU");
    case "AT":
      return t("countryNames.AT");
    case "BE":
      return t("countryNames.BE");
    case "BW":
      return t("countryNames.BW");
    case "BR":
      return t("countryNames.BR");
    case "BN":
      return t("countryNames.BN");
    case "BG":
      return t("countryNames.BG");
    case "CL":
      return t("countryNames.CL");
    case "CN":
      return t("countryNames.CN");
    case "CO":
      return t("countryNames.CO");
    case "CR":
      return t("countryNames.CR");
    case "HR":
      return t("countryNames.HR");
    case "CZ":
      return t("countryNames.CZ");
    case "DK":
      return t("countryNames.DK");
    case "SV":
      return t("countryNames.SV");
    case "EE":
      return t("countryNames.EE");
    case "FI":
      return t("countryNames.FI");
    case "FR":
      return t("countryNames.FR");
    case "DE":
      return t("countryNames.DE");
    case "GR":
      return t("countryNames.GR");
    case "GT":
      return t("countryNames.GT");
    case "HN":
      return t("countryNames.HN");
    case "HK":
      return t("countryNames.HK");
    case "HU":
      return t("countryNames.HU");
    case "ID":
      return t("countryNames.ID");
    case "IE":
      return t("countryNames.IE");
    case "IT":
      return t("countryNames.IT");
    case "JP":
      return t("countryNames.JP");
    case "KZ":
      return t("countryNames.KZ");
    case "KG":
      return t("countryNames.KG");
    case "LV":
      return t("countryNames.LV");
    case "LT":
      return t("countryNames.LT");
    case "MY":
      return t("countryNames.MY");
    case "MX":
      return t("countryNames.MX");
    case "NA":
      return t("countryNames.NA");
    case "NL":
      return t("countryNames.NL");
    case "NZ":
      return t("countryNames.NZ");
    case "NO":
      return t("countryNames.NO");
    case "PA":
      return t("countryNames.PA");
    case "PH":
      return t("countryNames.PH");
    case "PL":
      return t("countryNames.PL");
    case "PT":
      return t("countryNames.PT");
    case "RO":
      return t("countryNames.RO");
    case "RU":
      return t("countryNames.RU");
    case "SG":
      return t("countryNames.SG");
    case "SK":
      return t("countryNames.SK");
    case "SI":
      return t("countryNames.SI");
    case "ZA":
      return t("countryNames.ZA");
    case "KR":
      return t("countryNames.KR");
    case "ES":
      return t("countryNames.ES");
    case "SE":
      return t("countryNames.SE");
    case "CH":
      return t("countryNames.CH");
    case "TW":
      return t("countryNames.TW");
    case "TR":
      return t("countryNames.TR");
    case "UA":
      return t("countryNames.UA");
    case "GB":
      return t("countryNames.GB");
    case "UY":
      return t("countryNames.UY");
    case "VE":
      return t("countryNames.VE");
    case "VN":
      return t("countryNames.VN");
    case "MN":
      return t("countryNames.MN")
    default:
      return "-";
  }
};

export const getTrackingStatusNameFromCode = (
  code: string | number | undefined,
  t: any
) => {
  switch (code) {
    case 2:
      return t("trackingName.achieved");
    case 1:
      return t("trackingName.tracking");
    default:
      return "-";
  }
};

export const getToTitleCase = (name: string) => {
  return name
    ?.toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};
